<template>
    <!-- 单选题 -->
    <div class="question-item">
        <div class="question-item-num">
            <question-title v-if="titleIsEdit" :dataList="dataList" @numberBlur="(e) => emits('numberChange', e)" />
            <div v-else style="margin-top: 8px">{{ dataList.questionNumber }}</div>
        </div>
        <div class="question-item-content">
            <div class="title">
                <rich-text-editor ref="titileInput" class="titile-input" v-model:valueData="dataList.title" />
            </div>
            <div class="content">
                <div class="score-box" v-if="dataList.icon === 'Number'">
                    <div class="score-icon" v-for="(item, index) in 5" :key="index">
                        <div
                            class="score-icon_number"
                            :style="{
                                background: index === 0 ? 'rgba(34, 64, 195, 1)' : '',
                                color: index === 0 ? '#fff' : '',
                            }"
                        >
                            {{ item }}
                        </div>
                        <div class="score-explain">
                            <span v-if="dataList.explainsList[index + 1] && [0, 4].includes(index)">
                                {{ dataList.explainsList[index + 1].explainDes }}
                            </span>
                        </div>
                    </div>
                </div>
                <div v-else class="score-box">
                    <div class="score-icon" v-for="(item, index) in dataList.score">
                        <img v-if="index === 0" :src="getAssetsImages(dataList.icon + '_light')" />
                        <img v-else :src="getAssetsImages(dataList.icon)" />
                        <div class="score-explain">
                            <span style="left: 0" v-if="index == 0 && dataList.explainsList[index + 1]">{{
                                dataList.explainsList[index + 1].explainDes
                            }}</span>
                            <span style="right: 0" v-if="index == 4 && dataList.explainsList[index + 1]">{{
                                dataList.explainsList[index + 1].explainDes
                            }}</span>
                            <!-- <span v-if="dataList.explainsList[index + 1] && [0, 4].includes(index)">
                                {{ dataList.explainsList[index + 1].explainDes }}
                            </span> -->
                        </div>
                    </div>
                </div>
            </div>
            <!-- 底部操作栏 -->
            <div class="footer-operation" v-if="footerShow">
                <action-bar
                    class="action-bar"
                    @addCopy="() => emits('copyQuestion', dataList)"
                    @deleteQuestion="() => emits('deleteQuestion')"
                    @view="(e) => emits('singlePreview', e)"
                >
                    <!-- 添加左侧操作按钮 -->
                    <template #operation>
                        <div class="bottom-operation">
                            <div class="button1" @click="openEditDialog"><svg-icon name="batchEdit" class="icon" />编辑选项</div>
                        </div>
                    </template>
                </action-bar>
            </div>
            <!--  编辑选项弹框 -->
            <evaluation-dialog ref="editDialog" :question="dataList" @confirmEdit="confirmEdit" />
        </div>
    </div>
</template>
<script setup name="kr-evaluation">
// js
import { ref, watch, provide } from "vue";
import { getAssetsImages } from "@/utils/index";
// components
import RichTextEditor from "@/components/editor/RichTextEditor.vue";
import ActionBar from "@/components/action/ActionBar.vue";
import EvaluationDialog from "@/components/dialog/EvaluationDialog.vue";
import QuestionTitle from "@/components/question/QuestionNumber.vue";

// props
const props = defineProps({
    // 是否展示底部操作栏
    footerShow: {
        type: Boolean,
        default: true,
    },
    // 题号是否可编辑
    titleIsEdit: {
        type: Boolean,
        default: true,
    },
    // 数据渲染
    dataList: {
        type: Object,
        default: () => ({}),
    },
});
// 复制题目，删除题目, 数据改变, 单题预览;
const emits = defineEmits(["copyQuestion", "deleteQuestion", "change", "singlePreview", "numberChange"]);
const editDialog = ref(null);
const titileInput = ref(null);
watch(
    () => props.dataList,
    (curr, old) => {
        // 绑定数据改变时调change方法
        emits("change", curr);
    },
    { deep: true }
);

// 可能会在外面改变内部输入框的聚焦情况
defineExpose({ titileInput });
provide("data", props.dataList);

// 打开批量编辑选项弹框
function openEditDialog() {
    editDialog.value.editDialogVisible = true;
}
function confirmEdit(data) {
    props.dataList.explainsList = data.explainsList;
}
</script>
<style lang="scss" scoped>
@use "@/css/common.scss" as *;

.question-item {
    .content {
        .score-box {
            display: flex;
            .score-icon {
                width: 32px;
                min-height: 32px;
                margin-right: 25px;
                display: flex;
                flex-direction: column;
                white-space: nowrap;

                img {
                    width: 32px;
                    height: 32px;
                }

                .score-explain {
                    height: 18px;
                    margin-top: 10px;
                    color: rgba(112, 120, 134, 1);
                    font-size: 12px;
                    position: relative;
                    span {
                        position: absolute;
                        top: 50%;
                        transform: translateY(-50%);
                    }
                }
            }
            .score-icon_number {
                width: 32px;
                height: 32px;
                border: 1px solid rgba(228, 229, 232, 1);
                color: rgba(102, 102, 102, 1);
                border-radius: 50%;
                line-height: 29px;
                text-align: center;
            }
        }
        .icon {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);
            left: 14px;
            width: 16px;
            height: 16px;
            border-radius: 50%;
            border: 1px solid #ccc;
            background-color: #fff;
        }
    }
}
</style>
